<template>
  <div>
    <div ref="echartHx" :style="{width: '100%', height: '320px'}"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
      this.echartHx()
  },
  methods: {
    echartHx() {
        let myChart = this.$echarts.init(this.$refs.echartHx);
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: 10,
          data: ["在线设备", "离线设备" ],
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "30",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: 335, name: "在线设备" },
              { value: 120, name: "离线设备" },
              // { value: 234, name: "联盟广告" },
              // { value: 135, name: "视频广告" },
            //   { value: 1548, name: "搜索引擎" },
            ],
          },
        ],
      };
      myChart.setOption(option)
    },
  },
};
</script>

<style scoped lang="less">
</style>
